<bz-return-btn-arrow (pushBtnReturn)="pushBtnBack()" class="btn-back">
  <p *ngIf="catalog">{{ catalog?.name_short }}</p>
</bz-return-btn-arrow>

<div class="catalog-wrapper">

  <main>
  <div class="desktop">
    <h1 *ngIf="!bufferCatalog" class="root-catalog-title">Каталог</h1>
    <div class="columns-wrapper">
      <ng-container *ngIf="!bufferCatalog">
        <div class="column" *ngFor="let category of catalog?.children; trackBy: trackById">
          <div class="column-title-wrapper">

            <p class="column-title">
              <a (click)="resetCategoryPage()" [routerLink]="toSecondRouterLinkLevelOfCatalog(category)">
                {{category?.name_short}}</a>
            </p>

            <span class="line"></span>
          </div>


          <div class="ul-list">
            <ul>
              <ng-container *ngFor="let ch of category?.children; let i = index; trackBy: trackById">
                <li class="list-group">

                  <p class="category-name">
                    <a (click)="resetCategoryPage()" [routerLink]="toSecondRouterLinkLevelOfCatalog(ch)">
                      {{ch?.name_short}}</a>
                  </p>

                </li>
              </ng-container>
            </ul>

            <span class="show-all">
              <a (click)="resetCategoryPage()" [routerLink]="toSecondRouterLinkLevelOfCatalog(category)">
                {{'allSubCategories' | transloco}}
              </a>
            </span>

          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="bufferCatalog">
        <div class="desktop-wrapper-v2">
          <nav class="categories-sidebar">
            <span class="sidebar-header">{{ h1?.seoH1 }}</span>
            <ng-container *ngFor="let category of catalog?.children; trackBy: trackById">
              <a class="category-link" (click)="resetCategoryPage(category?.id)"
                [routerLink]="toSecondRouterLinkLevelOfCatalog(category)">
                {{ category?.name_short }}
              </a>
            </ng-container>
          </nav>

          <div class="right-side-content">
            <div class="title-with-crumbs" *ngIf="bufferCatalog">
              <div class="catalog-btn-wrapper navigation">
                <div class="catalog-btn">
                  <a (click)="resetCategoryPage()" [routerLink]="getHomePageLink()">{{ 'search-for-drugs' | transloco
                    }}</a>
                </div>
                <ng-container *ngFor="let crumb of catalog?.crumbs; let i = index; trackBy: trackById">
                  <div class="catalog-btn" *ngIf="i > 0">
                    <a (click)="resetCategoryPage()" [routerLink]="toSecondRouterLinkLevelOfCatalog(crumb)">{{
                      crumb?.name }}</a>
                  </div>
                </ng-container>
                <div class="catalog-btn">
                  <a>{{ h1?.seoH1 }}</a>
                </div>
              </div>
            </div>

            <h1 class="catalog-title">{{ h1?.seoH1 }}</h1>

            <div class="groups-wrapper">
              <ng-container *ngFor="let group of groups; last as lastGroup; trackBy: trackById">
                <div class="single-group">
                  <div class="left-arrow" [id]="'left-arrow-' + group.name_short"
                    (click)="scrollProductsContainer('left', group.name_short)">
                    <img src="../../../assets/icons/nav-arrow.svg">
                  </div>
                  <div class="single-group__header">
                    <h2 class="single-group__header-title">{{ group.name_short }}</h2>
                    <a class="single-group__header-show-more" (click)="resetCategoryPage(group.id)"
                      [routerLink]="getLinkForMore(group.id)">
                      {{ 'showAll' | transloco }}
                    </a>
                  </div>
                  <div [class.last-group]="lastGroup" class="single-group__bottom scrollbar-x-unvisible"
                    [id]="'single-group__bottom-' + group.name_short">
                    <ng-container *ngFor="let product of group.products; trackBy: trackById">
                      <bz-product [BzProduct]="product" [isCatalogPage]="true" [isBtnToMenu]="false"></bz-product>
                    </ng-container>
                  </div>
                  <div class="right-arrow" [id]="'right-arrow-' + group.name_short"
                    (click)="scrollProductsContainer('right', group.name_short)">
                    <img src="../../../assets/icons/nav-arrow.svg">
                  </div>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </ng-container>

    </div>

  </div>

  <div class="mobile">
    <div class="mobile-first-level-wrapper">
      <ng-container *ngFor="let category of catalog?.children; trackBy: trackById">
        <div class="mobile-first-level-category">
          <img *ngIf="!bufferCatalog" class="category-image" [src]="'../../../assets/catalog-icons/' + category?.image"
            alt="category" [title]="category?.name">
          <a class="category-title" (click)="resetCategoryPage()"
            [routerLink]="toSecondRouterLinkLevelOfCatalog(category)">
            {{category?.name_short}}
          </a>
        </div>
      </ng-container>
    </div>
  </div>

  <div class="table-prices-text-wrapper">
    <div class="inner">
      <ng-container *ngTemplateOutlet="banner"></ng-container>
      <ng-container *ngTemplateOutlet="seoAuthor"></ng-container>
      <ng-container *ngTemplateOutlet="tableDataSource"></ng-container>
      <ng-container *ngTemplateOutlet="tableSeoText"></ng-container>
    </div>
  </div>

  </main>

  <div class="static-footer">
    <ng-container *ngTemplateOutlet="footer"></ng-container>
  </div>

</div>

<ng-template #tableDataSource>
  <ng-container *ngIf="table">
    <bz-prices-table
      [isCatalogPage]="true"
      [table]="table"
      [lang]="lang"
      [tableHeading]="('price-on' | transloco) + ' ' + table.ctName + ' ' + ('in' | transloco) + ' ' + currentYear"
      (onResetCategoryPage)="resetCategoryPage()">
    </bz-prices-table>
  </ng-container>
</ng-template>

<ng-template #tableSeoText>
  <ng-container *ngIf="text">
    <div class="table-text-content" [class.full-text]="showFullSeoText" [innerHTML]="text | safeHTML"></div>
    <div class="read-more" (click)="readMoreSeoText()">{{ showFullSeoText ? ('hide' | transloco) : ('read-more' | transloco) }}</div>
  </ng-container>
</ng-template>

<ng-template #seoAuthor>
  <ng-container *ngIf="editor">
    <bz-instruction-author
      class="seo-editor"
      [showLeftSide]="false"
      [seoControl]="{ editor: editor }"
    ></bz-instruction-author>
  </ng-container>
</ng-template>

<ng-template #banner>
  <div class="banner" *ngIf="adBanner">
    <a [href]="adBanner.redirectTo">
      <picture class="banner-picture">
        <source [srcset]="bannerImages + adBanner.img + '.webp'" type="image/webp">
        <img bz-image [src]="bannerImages + 'png/' + adBanner.img + '.png'" [title]="'Банер'" [alt]="'Банер'">
      </picture>
    </a>
  </div>
</ng-template>

<ng-template #footer>
  <bz-static-footer></bz-static-footer>
</ng-template>
